module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ShareItems"
  }, [_c('a', {
    staticClass: "ShareItems-item",
    attrs: {
      "href": _vm.facebookUrl
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.open('facebook')
      }
    }
  }, [_c('icon', {
    staticClass: "ShareItem-icon",
    attrs: {
      "name": "facebook"
    }
  })], 1), _vm._v(" "), (_vm.data.vimeoId) ? _c('a', {
    staticClass: "ShareItems-item",
    attrs: {
      "href": _vm.vimeoUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.open
    }
  }, [_c('icon', {
    staticClass: "ShareItem-icon",
    attrs: {
      "name": "vimeo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "ShareItems-item",
    attrs: {
      "href": _vm.emailUrl
    },
    on: {
      "click": _vm.open
    }
  }, [_c('icon', {
    staticClass: "ShareItem-icon",
    attrs: {
      "name": "email"
    }
  })], 1), _vm._v(" "), (_vm.data.vimeoId && !_vm.window.supportsTouch) ? _c('a', {
    staticClass: "ShareItems-item",
    attrs: {
      "href": _vm.vimeoEmbedUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.open
    }
  }, [_c('icon', {
    staticClass: "ShareItem-icon",
    attrs: {
      "name": "embed"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-485cf5a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareItems.vue
// module id = 765
// module chunks = 1474